export function idValidation(id: string | undefined): boolean {
    if (id && id.length === 11) {
        // Get the chechsum from id
        const rnnChecksum = parseInt(id.substring(9));

        // Get the part of id that is used to calculate the checksum
        let partToCalc = id.substring(0, 9);
        // convert the part to integer
        let rnnInt = parseInt(partToCalc);

        //Calculate and check
        let checkSum = 97 - (rnnInt % 97);
        if (checkSum === rnnChecksum) {
            return true
        }

        // checksum is false (probably because year is > 2) add a 2 before and repeat
        partToCalc = '2' + id.substring(0, 9);
        rnnInt = parseInt(partToCalc);

        checkSum = 97 - (rnnInt % 97);
        if (checkSum === rnnChecksum) {
            return true
        }
    }
    return false;
}